var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.showLadder()}}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"size":"22"}},[_vm._v(" mdi-ladder ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }